export const adobePageViewEvent = (lang: string) => {
    window.adobeDataLayer?.push({
        event: 'pageview',
        page: {
            name: '',
            id: 'prioritycard-website-2025',
            language: lang === 'zh' ? 'zh-hk' : lang,
        },
        user: {
            cuno: window?.WCIPCookie?.getCuno() || '',
            customer_segment: window?.WCIPCookie?.getCustomerSegment() || '',
        },
    })
}

interface AdobeInteractionProps {
    lang: string
    eventID: string
    videoFileName?: string
    contentTitle?: string
    contentUrl?: string
}

export const adobeInteractionEvent = (props: AdobeInteractionProps) => {
    const { lang, eventID, videoFileName, contentTitle, contentUrl } = props
    window.adobeDataLayer?.push({
        event: 'interaction',
        page: {
            name: '',
            id: 'prioritycard-website-2025',
            language: lang === 'zh' ? 'zh-hk' : lang,
        },
        interaction: {
            eventID: eventID,
            video_filename: videoFileName || '',
        },
        content: {
            title: contentTitle || '',
            URL: contentUrl || '',
        },
        user: {
            cuno: window?.WCIPCookie?.getCuno() || '',
            customer_segment: window?.WCIPCookie?.getCustomerSegment() || '',
        },
    })
}
